module.exports = __webpack_public_path__ + "img/nota-sargazo.f7071361.jpg";